import { render, staticRenderFns } from "./SecondReviewer.vue?vue&type=template&id=d39ff728"
import script from "./SecondReviewer.vue?vue&type=script&lang=js"
export * from "./SecondReviewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports